// ⚠️ COMPONENTE OCULTO: Reemplazado por StandardLeftSidebar según ACV-SystemDesign.md
// Este componente se mantiene solo para referencia, pero no se usa en producción

import React from 'react';
// Imports comentados - no se usan porque el componente está oculto
// import { useEffect, useState } from 'react';
// import { ChevronLeft, ChevronRight, Video, Users } from 'lucide-react';

interface CollapsibleSidebarProps {
  children: React.ReactNode;
  className?: string;
  onNavigate?: (tab: string) => void;
  onOpenRecording?: () => void;
  sidebarType?: 'main' | 'shared';
  initiallyCollapsed?: boolean;
}

const CollapsibleSidebar: React.FC<CollapsibleSidebarProps> = ({ 
  children, 
  className = '',
  onNavigate,
  onOpenRecording,
  sidebarType = 'main',
  initiallyCollapsed = false,
}) => {
  // Componente oculto - retornar null para no renderizar
  // Reemplazado por StandardLeftSidebar según ACV-SystemDesign.md
  return null;
};

export default CollapsibleSidebar;
